import type { HttpClient } from '../http/HttpClient.ts';

export interface HealthReport {
  status: 'ok' | 'degraded';
  version: string;
  checks: { database: 'up' | 'down' };
}

/** Service health (status indicator, deploy checks). */
export class HealthApi {
  readonly #http: HttpClient;

  constructor(http: HttpClient) {
    this.#http = http;
  }

  /** 503 carries a valid (degraded) report, so it is returned rather than thrown. */
  get({ signal }: { signal?: AbortSignal } = {}): Promise<HealthReport> {
    return this.#http.get<HealthReport>('/health', {
      ...(signal ? { signal } : {}),
      okStatuses: [503],
    });
  }
}
